export const maintenanceStrategyList: Array<string> = ['待定', 'P0', 'P1', 'P2', 'P3'];

export const meetingCategoryMap: object = {
  1: 'Early',
  2: 'Early Growth',
  3: 'Growth',
  5: 'Late Growth',
  6: 'Seed'
};

export const meetingCategoryMapFull: object = {
  1: 'Venture-Early',
  2: 'Venture-Early Growth',
  3: 'Growth-Growth',
  5: 'Growth-Late Growth',
  6: 'Seed-Seed'
};

export const meetingGoalMap: object = {
  1: 'InterestingCase',
  2: 'Onepager',
  3: 'DD Memo(Pre-TS)',
  4: 'DD Memo(Pre-SPA)',
  5: 'DD Memo(Pre交割)',
  7: 'PreLoan',
  8: 'CEO meeting',
  9: 'offline讨论'
};

export const creatMeetingColumns: Array<object> = [
  {
    title: '项目名称',
    width: '300px',
    key: 'name',
    align: 'left',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '项目描述',
    width: '120px',
    dataIndex: 'description',
    key: 'description',
    align: 'left',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: 'DL',
    width: '100px',
    dataIndex: 'dealLeadersName',
    key: 'dealLeadersName',
    align: 'left'
  },
  {
    title: '上会分类',
    width: '150px',
    dataIndex: 'meetingCategory',
    key: 'meetingCategory',
    align: 'left',
    customRender: (e, row, index) => {
      return {
        children: meetingCategoryMap[e]
      };
    }
  },
  {
    title: '上会目的',
    width: '170px',
    dataIndex: 'meetingGoal',
    key: 'meetingGoal',
    align: 'left',
    customRender: (e, row, index) => {
      return {
        children: meetingGoalMap[e]
      };
    }
  },
  {
    title: '上会时间',
    width: '300px',
    // dataIndex: 'meetingDate',
    key: 'meetingDate',
    align: 'left',
    scopedSlots: { customRender: 'meetingDate' }
  },
  {
    title: '需要时间',
    width: '100px',
    dataIndex: 'needTime',
    key: 'needTime',
    align: 'left',
    customRender: e => {
      return {
        children: e && e !== '0' ? e + '分钟' : ''
      };
    }
  },
  {
    title: '参会人',
    width: '180px',
    dataIndex: 'meetingUsers',
    key: 'meetingUsers',
    align: 'left',
    scopedSlots: { customRender: 'meetingUsers' }
  },
  {
    title: '飞书群',
    width: '250px',
    key: 'groupName',
    align: 'left',
    scopedSlots: { customRender: 'groupName' }
  },
  {
    // title: '群通知',
    width: '100px',
    // dataIndex: 'notice',
    key: 'notice',
    align: 'left',
    slots: { title: 'noticeTitle' },
    scopedSlots: { customRender: 'notice' }
  },
  {
    title: '操作',
    width: '100px',
    key: 'action',
    align: 'left',
    scopedSlots: { customRender: 'action' }
  }
];

export const meetingListColumns: Array<object> = [
  {
    title: '项目名称',
    width: '16%',
    key: 'name',
    align: 'left',
    scopedSlots: { customRender: 'name' }
  },
  {
    title: '项目描述',
    width: '10%',
    dataIndex: 'description',
    key: 'description',
    align: 'left',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: 'DL',
    width: '6%',
    dataIndex: 'dealLeadersName',
    key: 'dealLeadersName',
    align: 'left'
  },
  {
    title: '上会分类',
    width: '8%',
    dataIndex: 'meetingCategory',
    key: 'meetingCategory',
    align: 'left',
    customRender: (e, row, index) => {
      return {
        children: meetingCategoryMap[e]
      };
    }
  },
  {
    title: '上会目的',
    width: '13%',
    dataIndex: 'meetingGoal',
    key: 'meetingGoal',
    align: 'left',
    customRender: (e, row, index) => {
      return {
        children: meetingGoalMap[e]
      };
    }
  },
  {
    title: '上会时间',
    width: '16%',
    // dataIndex: 'meetingDate',
    key: 'meetingDate',
    align: 'left',
    scopedSlots: { customRender: 'meetingDate' }
  },
  {
    title: '所属会议',
    width: '21%',
    dataIndex: 'meetingName',
    key: 'meetingName',
    align: 'left',
    customRender: (e, row, index) => {
      return {
        children: e
      };
    }
  },
  {
    title: '操作',
    width: '10%',
    key: 'action',
    align: 'left',
    scopedSlots: { customRender: 'action' }
  },
  {
    title: '操作',
    width: '10%',
    key: 'manageAction',
    align: 'left',
    scopedSlots: { customRender: 'manageAction' }
  }
];
export const supportList = [
  {
    id: 1,
    name: 'FDD'
  },
  {
    id: 2,
    name: 'LDD'
  },
  {
    id: 4,
    name: 'HDD'
  },
  {
    id: 8,
    name: 'ITDD'
  },
  {
    id: 16,
    name: '财务（人民币）'
  },
  {
    id: 32,
    name: '财务（美元）'
  },
  {
    id: 64,
    name: 'PDD'
  },
  {
    id: 128,
    name: '揽星'
  },
  {
    id: 1024,
    name: 'CMDD'
  },
  {
    id: 0,
    name: '暂无'
  }
];

export const roleMap = {
  1: 'FDD',
  2: 'LDD',
  4: 'HDD',
  8: 'ITDD',
  16: '财务（人民币）',
  32: '财务（美元）',
  64: 'PDD',
  128: '揽星',
  256: 'DM',
  512: 'DL',
  1024: 'CMDD'
};
